module.exports = __webpack_public_path__ + "static/media/gift.c56d4176.jpg";